import { bookingConstants } from '../utils/types';
import { modals, bookingErrorType } from '../utils/constants';
import { openModal } from './modalsActions';
import { setPendingBookingSessionEventId } from './pendingBookingActions';
import ApiClient from '../utils/apiClient';
import i18n from '../utils/i18n';

export function bookSessionRequest(
  sessionEventId,
  numberOfBookings,
  friendsEmails = null
) {
  const request = () => ({
    type: bookingConstants.SESSION_EVENT_BOOKING_REQUEST
  });
  const success = () => ({
    type: bookingConstants.SESSION_EVENT_BOOKING_SUCCESS
  });
  const failure = error => ({
    type: bookingConstants.SESSION_EVENT_BOOKING_FAILURE,
    payload: {
      error
    }
  });

  return dispatch => {
    dispatch(request());
    return ApiClient.post('/api/v1/book-slot-in-session/', {
      event_id: sessionEventId,
      invited_users_emails: friendsEmails || []
    })
      .then(() => {
        dispatch(success());
      })
      .catch(error => {
        let text = i18n.t('modals.booking.BOOKING_FAILED');
        if (
          error.response.data &&
          error.response.data.non_field_errors &&
          error.response.data.non_field_errors
        ) {
          [text] = error.response.data.non_field_errors;
        }
        dispatch(failure(text));
        throw error;
      });
  };
}

export function resetBooking() {
  return {
    type: bookingConstants.SESSION_EVENT_BOOKING_RESET
  };
}

export function bookSession(
  bookingsNumber,
  sessionEventId,
  eventDate,
  eventTime,
  sessionName,
  eventLocation,
  eventClubName,
  refreshAction,
  friendsEmails = null
) {
  return dispatch => {
    dispatch(bookSessionRequest(sessionEventId, bookingsNumber, friendsEmails))
      .then(() => {
        dispatch(setPendingBookingSessionEventId(null));
        dispatch(refreshAction);
        dispatch(
          openModal(modals.BOOKING_SESSION_COMPLETE, {
            eventDate,
            eventTime,
            bookingsNumber,
            sessionName,
            eventLocation,
            eventClubName
          })
        );
      })
      .catch(error => {
        const data = error && error.response && error.response.data;
        dispatch(resetBooking());

        if (data.error_type === bookingErrorType) {
          dispatch(openModal(modals.BOOKING_SESSION_FAILURE, data));
        }
      });
  };
}

export function startSessionBooking(
  bookingsNumber,
  sessionEventId,
  eventDate,
  eventTime,
  sessionName,
  eventLocation,
  eventClubName,
  refreshAction,
  inviteFriendsCount
) {
  return dispatch => {
    if (inviteFriendsCount > 0) {
      dispatch(
        openModal(modals.INVITE_FRIENDS_TO_SESSION_BOOKING, {
          bookingsNumber,
          sessionEventId,
          eventDate,
          eventTime,
          sessionName,
          eventLocation,
          eventClubName,
          refreshAction,
          inviteFriendsCount
        })
      );
    } else {
      dispatch(
        bookSession(
          bookingsNumber,
          sessionEventId,
          eventDate,
          eventTime,
          sessionName,
          eventLocation,
          eventClubName,
          refreshAction
        )
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/sessionsBookingActions.js